/**
 * Reviewer API client — all /api/reviewer/* calls.
 * Only used by the Review page. Requires a question_reviewer JWT.
 *
 * The reviewer surface is intentionally narrow: list the queue, open one,
 * edit it, submit it for admin approval, and read the topic taxonomy.
 */

const BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function getToken() {
  return localStorage.getItem('access_token');
}

async function reviewerRequest(path, options = {}) {
  const token   = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, { ...options, headers });

  let body;
  try { body = await res.json(); } catch { body = {}; }

  if (!res.ok) throw { status: res.status, ...body };
  return body;
}

// ── Topics ───────────────────────────────────────────────────────────────────
export const getTopics = (section) =>
  reviewerRequest(`/api/reviewer/topics${section ? '?section=' + section : ''}`);

// ── Queue ────────────────────────────────────────────────────────────────────
export const listQueue = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v != null))
  ).toString();
  return reviewerRequest(`/api/reviewer/questions${qs ? '?' + qs : ''}`);
};

export const getQuestion = (id) =>
  reviewerRequest(`/api/reviewer/questions/${id}`);

export const editQuestion = (id, data) =>
  reviewerRequest(`/api/reviewer/questions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const submitQuestion = (id, version) =>
  reviewerRequest(`/api/reviewer/questions/${id}/submit`, {
    method: 'POST',
    body: JSON.stringify({ version }),
  });
